import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appMytest]'
})
export class MytestDirective {

	@Input('appMytest') color:string;
	
	@HostListener('mouseenter') onmouseenter(){
		this.highlight(this.color);
	}
	
	@HostListener('mouseleave') onmouseleave(){
		this.highlight(null);
	}
	
	highlight(color):void
	{
		this.el.nativeElement.style.color = color;
	}
	
  constructor(
		private el:ElementRef,
	) { 
		
	}
	

}
